<template>
    <el-dialog
        v-if="permissionsShow"
        v-dialogDrag
        :title="title"
        :visible.sync="visible"
        :fullscreen="fullscreen"
        :top="top"
        :modal="modal"
        :lock-scroll="lockScroll"
        :custom-class="customClass"
        :close-on-click-modal="closeOnClickModal"
        :close-on-press-escape="closeOnPressEscape"
        :show-close="showClose"
        :before-close="beforeClose"
        :center="center"
        :width="width"
        :modal-append-to-body="modalAppendToBody"
        :append-to-body="appendToBody"
        @open="_open"
        @opened="_opened"
        @close="_close"
        @closed="_closed"
    >
        <slot></slot>
        <template slot="footer">
            <slot name="footer">
                <div style=" text-align: center;">
                    <td-button @click="closeDialog">{{ vm.$t('component.CANCEL') }}</td-button>
                </div>
            </slot>
        </template>
    </el-dialog>
</template>
<script>
export default {
    props: {
        /* Dialog 的标题 */
        title: {
            type: String
        },
        /* 是否显示 Dialog，支持 .sync 修饰符 */
        visible: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 是否为全屏 Dialog */
        fullscreen: Boolean,
        /* Dialog CSS 中的 margin-top 值，默认 15vh */
        top: {
            type: String,
            default: '15vh'
        },
        /* 是否需要遮罩层 */
        modal: {
            type: Boolean,
            default: true
        },
        /* 是否在 Dialog 出现时将 body 滚动锁定 */
        lockScroll: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        /* Dialog 的自定义类名 */
        customClass: {
            type: String,
            default: ''
        },
        /* 是否可以通过点击 modal 关闭 Dialog */
        closeOnClickModal: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        /* 是否可以通过按下 ESC 关闭 Dialog */
        closeOnPressEscape: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        /* 是否显示关闭按钮 */
        showClose: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        /* 是否对头部和底部采用居中布局 */
        center: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 关闭前的回调，会暂停 Dialog 的关闭 */
        beforeClose: {
            type: Function
        },
        width: String,
        /* 遮罩层是否插入至 body 元素上，若为 false，则遮罩层会插入至 Dialog 的父元素上 */
        modalAppendToBody: {
            type: Boolean,
            default: true
        },
        /* Dialog 自身是否插入至 body 元素上。嵌套的 Dialog 必须指定该属性并赋值为 true */
        appendToBody: {
            type: Boolean,
            default: false
        },
        /* 所有权限信息 */
        permissions: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 角色信息 */
        roles: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 权限之一 */
        oneOfPermissions: {
            type: Array,
            default: function() {
                return [];
            }
        }
    },
    data() {
        return {
            /* 是否满足显示权限 */
            permissionsShow: true,
            vm: window.vue
        };
    },
    methods: {
        closeDialog() {
            this.$emit('cancel');
        },
        /* Dialog 打开的回调 */
        _open() {
            this.$emit('open');
        },
        /* Dialog 打开动画结束时的回调 */
        _opened() {
            this.$emit('opened');
        },
        /* Dialog 关闭的回调 */
        _close() {
            this.$emit('close');
        },
        /* Dialog 关闭动画结束时的回调 */
        _closed() {
            this.$emit('closed');
        }
    }
};
</script>
<style>
.el-dialog__header {
    padding: 0px 10px 0px;
    height: 35px;
    line-height: 35px;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
.el-dialog__headerbtn {
    position: inherit;
    line-height: 35px;
    float: right;
}
.el-dialog__title {
    font-size: 16px !important;
}
.el-dialog {
    margin-bottom: 0px;
}
.el-dialog__body {
    padding: 0px 20px 0px;
}
.el-dialog__footer {
    padding: 0px 20px 20px;
}
</style>
